export default {
    state: {
        search_value: '',
        found: false
    },
    mutations: {
        SET_SEARCH_VALUE(state,payload){
            state.search_value = payload
        },
        SET_SEARCH_FOUND(state,payload){
            state.found = payload
        }
    },
    actions: {},
    getters: {
        search_value: state => {
            return state.search_value
        },
        found: state => state.found
    }
}
